import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnderageLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Calque_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "500px",
	height: "500px",
	viewBox: "0 0 500 500",
	enableBackground: "new 0 0 500 500",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .6,
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#F8F8F8",
				d: "M241.688,465.84c-119.016,0-215.84-96.824-215.84-215.84s96.824-215.84,215.84-215.84 c60.176,0,114.652,24.778,153.835,64.636c4.393-3.693,9.09-7.012,13.976-10.069c-42.407-44.11-101.936-71.644-167.811-71.644 C113.258,17.083,8.771,121.57,8.771,250s104.487,232.917,232.917,232.917c105.859,0,195.388-71.014,223.61-167.885 c-5.807-0.429-11.511-1.2-17.066-2.409C421.327,401.19,338.93,465.84,241.688,465.84z"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				fill: "#F8F8F8",
				points: "184,353 184,149 104,149 104,189 133,189 133,353  "
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#F8F8F8",
				d: "M214.652,261.232c-5.431,8.522-8.144,18.584-8.144,30.191c0,13.294,3.369,24.763,10.109,34.402 c6.74,9.645,15.868,16.991,27.384,22.047c11.513,5.053,24.29,7.582,38.332,7.582s26.819-2.529,38.335-7.582 c11.513-5.056,20.641-12.402,27.384-22.047c6.738-9.639,10.106-21.108,10.106-34.402c0-11.418-2.713-21.388-8.144-29.91 c-5.431-8.516-13.197-15.207-23.309-20.079c8.049-4.305,14.465-10.201,19.24-17.692c4.77-7.485,7.16-16.288,7.16-26.4 c0-10.109-2.624-19.329-7.866-27.662c-5.242-8.327-13.153-14.976-23.726-19.94c-10.582-4.959-23.642-7.441-39.18-7.441 c-15.543,0-28.646,2.482-39.316,7.441c-10.671,4.964-18.631,11.613-23.87,19.94c-5.245,8.333-7.863,17.553-7.863,27.662 c0,20.037,8.797,34.733,26.397,44.091C227.755,246.117,220.08,252.716,214.652,261.232z M264.78,186.952 c4.397-4.305,10.251-6.46,17.553-6.46s13.153,2.107,17.553,6.318c4.397,4.214,6.599,10.159,6.599,17.833 c0,7.302-2.246,13.108-6.738,17.414c-4.494,4.308-10.301,6.457-17.414,6.457c-7.116,0-12.919-2.104-17.411-6.318 c-4.494-4.211-6.74-9.97-6.74-17.272C258.182,197.251,260.38,191.261,264.78,186.952z M260.989,269.376 c5.428-4.772,12.541-7.16,21.344-7.16c8.611,0,15.587,2.435,20.924,7.302c5.334,4.87,8.002,11.421,8.002,19.659 c0,7.863-2.577,14.323-7.721,19.376c-5.153,5.056-12.219,7.582-21.205,7.582s-16.146-2.527-21.483-7.582 c-5.337-5.053-8.005-11.513-8.005-19.376C252.845,280.75,255.558,274.151,260.989,269.376z"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				fill: "#F8F8F8",
				points: "451,200 451,154 422,154 422,200 377,200 377,228 422,228 422,274 451,274 451,228 491,228  491,200  "
			})
		]
	})
});
export default SvgUnderageLogo;
